import * as React from 'react';
import { useMemo } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

type TStyles = {
    aplixSelectInputRoot: string;
};

const styles: TStyles = require('./AplixDropdown.less');

export type TProps = {
    disabled?: boolean;
    required?: boolean;
    value: string | null;
    label: string | null;
    selectableValues: string | null;

    onChange?: (value: string | null) => void;
};

export const AplixDropdown: React.FunctionComponent<TProps> = (props) => {
    const {onChange, value, disabled, required, selectableValues} = props;

    const values = useMemo(() => selectableValues ? selectableValues.split('|') : [], []);
    const label: string | null = useMemo(() => props.label ? (props.label + (required ? '*' : '')) : null, []);

    return (
        <div className={styles.aplixSelectInputRoot}>
            <Autocomplete
                value={value}
                options={values}
                disabled={disabled}
                disableClearable={required}
                renderInput={(params) => <TextField {...params} inputProps={{ ...params.inputProps, readOnly:true }} label={label} />}
                onInputChange={(_, value) => onChange && onChange(value)}/>
        </div>
    );
};